// Platform tag of an uploaded data set (fix-source-routing D2/D11). PURE — no React, no network.
//
// At upload, Boomerang detects which ad platform a file comes from (file name + platform-specific
// columns) and stores it on the data set (`platformTag`). GET /upload/files returns it per
// category (`category_platforms`) plus the platforms a customer can pick (`platform_options`).
// A detected tag stays "(detected)" until the customer confirms or changes it. Every sentence
// about the tag (`text`) comes from the backend; only the pill wording lives here.

// "Snapchat (detected)" until confirmed, then "Snapchat". Null when there's no tag.
export function platformPillText(tag) {
  if (!tag || !(tag.label || tag.key)) return null;
  const label = String(tag.label || tag.key);
  return isDetected(tag) ? `${label} (detected)` : label;
}

// True while the tag was found automatically and the customer hasn't confirmed it yet.
export function isDetected(tag) {
  return Boolean(tag) && tag.status !== "confirmed";
}

// The dropdown options ({key, label}) from a GET /upload/files response; empty when absent.
export function platformOptions(listResponse) {
  const list = listResponse && Array.isArray(listResponse.platform_options) ? listResponse.platform_options : [];
  return list
    .filter((o) => o && o.key)
    .map((o) => ({ key: String(o.key), label: String(o.label || o.key) }));
}

// {category: tag} from a GET /upload/files response; {} when absent.
export function categoryPlatforms(listResponse) {
  const map = listResponse && listResponse.category_platforms;
  return map && typeof map === "object" && !Array.isArray(map) ? map : {};
}
